module.exports = __webpack_public_path__ + "static/media/healthfy-incentivos.c71f2fd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/healthfy-incentivos.jpg
// module id = 835
// module chunks = 0